import { useDocumentTitle } from 'shared/layout/DocumentTitle';
import { PromoPageContent } from '../../../profile/superpay/promo/PromoPageContent';
import { SUPERPAY_WEBVIEW_ROUTES } from '../../../profile/superpay/SuperPayRoute';
import { SuperPayWebviewHeader } from './SuperPayWebviewHeader';

export function PromoWebViewPage() {
  useDocumentTitle('Setup SuperPay');

  return (
    <SuperPayWebviewHeader>
      <PromoPageContent
        setupLink={`${SUPERPAY_WEBVIEW_ROUTES.businessDetails}?utm_medium=Promo Page`}
      />
    </SuperPayWebviewHeader>
  );
}
